import * as React from 'react';
import { Experiment } from '@cian/experiments/ab';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253219, будет удалён в задаче CD-253242
 */
export const experimentToggle = (
  isActive: boolean,
  experimentName: string,
  experimentGroupName?: string | null,
  controlGroup?: React.ReactNode,
  experimentGroup?: React.ReactNode,
) => {
  if (!isActive) {
    return controlGroup || null;
  }

  return (
    <>
      {controlGroup && (
        <Experiment name={experimentName} group="A" default>
          {controlGroup}
        </Experiment>
      )}
      {experimentGroup && experimentGroupName && (
        <Experiment name={experimentName} group={experimentGroupName}>
          {experimentGroup}
        </Experiment>
      )}
    </>
  );
};
